import { useModelService } from 'services/model/model.service';
import { InfoDrawerKpiEntry, measureKpi } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';

function usePerformanceEntityInfoContentKpis(): InfoDrawerKpiEntry[] {
  const { getMeasures } = useModelService();

  const [ordQty, retQtyRate, netSlsQty, netSlsGmvVal] = getMeasures([
    'ordQty',
    'retQtyRateExpOD',
    'netSlsQtyExpOD',
    'netSlsGmvValExpOD',
  ]);

  return [measureKpi(ordQty), measureKpi(retQtyRate), measureKpi(netSlsQty), measureKpi(netSlsGmvVal)];
}

export function PerformanceEntityInfoContent() {
  const kpis = usePerformanceEntityInfoContentKpis();

  return <InfoDrawerKpis.Default kpis={kpis} whyUsefulDescriptionId="performance.info.whyUseful.entity.description" />;
}
